import logo from "./logo.svg";
import "./App.css";
import Navbar from "./component/Navbar";
import Hero from "./component/Hero";
import Feature from "./component/Feature";
import GetStarted from "./component/GetStarted";
import CustomerJourney from "./component/CustomerJourney";
import EngagingContent from "./component/EngaginContent";
import CustomerValue from "./component/CustomerValue";
import Integrations from "./component/Integrations";
import Disclaimers from "./component/Disclaimers";
import Footer from "./component/Footer";

function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Feature />
        <GetStarted />
        <CustomerJourney />
        <EngagingContent />
        <CustomerValue />
        <Integrations />
        <Disclaimers />
      </main>
      <Footer />
    </>
  );
}

export default App;
